import Toast from "components/Toast";
import { toast , ToastOptions} from "react-toastify";

export class OnahToasts {

   static success(message: string, options?: ToastOptions & {title?: string})  {
       const {title, ...opt} = options || {};
        return toast.success((props) => {
            return <Toast {...props} title={title} message={message}/>
        }, {...opt, theme:"light", className: "onah-toast", icon: false, closeButton: false})
    }
    static error(message: string, options?: ToastOptions & {title?: string}){
        const {title,...opt} = options || {};
        return toast.error((props) => <Toast {...props} title={title} message={message} />, {...opt, theme:"light", className: "onah-toast", icon: false, closeButton: false})
    }
    static warn(message: string, options?: ToastOptions & {title?: string}){
       const {title, ...opt} = options || {};
        return toast.warn((props) => <Toast {...props} title={title} message={message}/>, {...opt, theme:"light", className: "onah-toast", icon: false, closeButton: false})
    }
    static info(message: string, options?: ToastOptions & {title?: string}){
        const {title, ...opt} = options || {};
         return toast.info((props) => <Toast {...props} title={title} message={message}/>, {...opt, theme:"light", className: "onah-toast", icon: false, closeButton: false})
     }
}